import { Component, OnInit, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import * as firebase from 'firebase'
import { from } from 'rxjs';
import {GranServicioDePTWService } from '../gran-servicio-de-ptw.service'
import {ServicioLoadersAlertasService} from '../servicio-loaders-alertas.service'

@Component({
  selector: 'app-modal-herramientas-ycontroles',
  templateUrl: './modal-herramientas-ycontroles.page.html',
  styleUrls: ['./modal-herramientas-ycontroles.page.scss'],
})
export class ModalHerramientasYControlesPage implements OnInit {

  @Input() actividad;
  @Input() item



  herramientasYControlesTrabajoEnAlturas = {
    herramientas: { arneses: 0, andamios: 0, eslingas: 0, eslingaDePosicionamiento: 0, cascos: 0, tieOff: 0, poleas: 0, descendedor: 0, gibbs: 0, lineaDeVida: 0, arrestador: 0, mosquetones: 0, cuerdas: 0, escaleras: 0, cintaDeAnclaje: 0, pertiga: 0, otros: 0 },
    actividadIncluye: [],
    peligros: [],
    controles: []
  }

  herramientasYControlesTrabajoEnCaliente = {
    herramientas: { pulidoras: 0, motosoldadores: 0, esmeriles: 0, plantasElectricas: 0, taladrosPercutores: 0, sierras: 0, motosierras: 0, guadanas: 0, otrosChispas: 0, otros: 0 },
    actividadIncluye: [],
    peligros: [],
    controles: []
  }

  herramientasYControlesLevantamientoMecanico = {
    herramientas: { grua: 0, camionBrazoGrua: 0, montacargas: 0, telehandlers: 0, aparejos: 0, gibbs: 0, arrestadores: 0, mosquetones: 0, cuerdas: 0, otros: 0 },
    actividadIncluye: [],
    peligros: [],
    controles: []
  }

  herramientasYControlesEnergiasPeligrosas = {
    herramientas: { otros: 0 },
    actividadIncluye: [],
    peligros: [],
    controles: []
  }

  herramientasYControlesEspaciosConfinados = {
    herramientas: { otros: 0 },
    actividadIncluye: [],
    peligros: [],
    controles: []
  } 

  herramientasYControlesHazmat = {
    herramientas: { otros: 0 },
    actividadIncluye: [],
    peligros: [],
    controles: []
  }

  herramientasYControlesSupervicionYmonitoreo = {
    herramientas: { otros: 0 },
    actividadIncluye: [],
    peligros: [],
    controles: []
  } 

  herramientasYControlesOtros = {
    herramientas: { otros: 0 },
    actividadIncluye: [],
    peligros: [],
    controles: []
  } 

        

  constructor(public modalCtrl: ModalController,public granServicioDePTWService:GranServicioDePTWService, public servicioLoadersAlertasService:ServicioLoadersAlertasService) { }

  ngOnInit() {
  }

  cancelar(){
    this.modalCtrl.dismiss({
      actividadActualizada:this.actividad.actividad
    }); 
  }

  ionViewWillEnter(){
    if(this.actividad == 'TRABAJO EN ALTURAS' && this.item.herramientasYcontroles != undefined){
        this.herramientasYControlesTrabajoEnAlturas = this.item.herramientasYcontroles
    }else
    if(this.actividad == 'TRABAJO EN CALIENTE' && this.item.herramientasYcontroles != undefined){
      this.herramientasYControlesTrabajoEnCaliente = this.item.herramientasYcontroles
    }else
    if(this.actividad == 'LEVANTAMIENTO MECÁNICO' && this.item.herramientasYcontroles != undefined){
      this.herramientasYControlesLevantamientoMecanico = this.item.herramientasYcontroles
    }else
    if(this.actividad == 'ENERGÍAS PELIGROSAS' && this.item.herramientasYcontroles != undefined){
      this.herramientasYControlesEnergiasPeligrosas = this.item.herramientasYcontroles
    }else
    if(this.actividad == 'ESPACIOS CONFINADOS' && this.item.herramientasYcontroles != undefined){
      this.herramientasYControlesEspaciosConfinados = this.item.herramientasYcontroles
    }else
    if(this.actividad == 'HAZMAT' && this.item.herramientasYcontroles != undefined){
      this.herramientasYControlesHazmat = this.item.herramientasYcontroles
    }else
    if(this.actividad == 'SUPERVISIÓN Y MONITOREO' && this.item.herramientasYcontroles != undefined){
      this.herramientasYControlesSupervicionYmonitoreo = this.item.herramientasYcontroles
    }else
    if(this.actividad == 'OTROS' && this.item.herramientasYcontroles != undefined){
      this.herramientasYControlesOtros = this.item.herramientasYcontroles
    }
    
  }
  






}
